import { groupThousands } from "@/lib/labels";

/**
 * Числа панели библиотеки (design.md stage7-library-panel, решение 5).
 * Это подпись, а не домен: агрегаты посчитаны демоном и здесь только
 * показываются. `null` — величина без единого наблюдения — прочерк, а не
 * ноль; ноль, который наблюдался, остаётся нулём.
 */

/** Прочерк отсутствующей величины. */
export const MISSING = "—";

/** Десятичная запятая вместо точки, `-0` после округления без знака. */
function fixedRu(value: number, digits: number): string {
  const text = value.toFixed(digits);
  const unsigned = /^-0(\.0+)?$/.test(text) ? text.slice(1) : text;
  return unsigned.replace(".", ",");
}

/** Отскок и дисконт — проценты с двумя знаками: «0,50 %». */
export function formatPercent(value: number | null): string {
  return value === null ? MISSING : `${fixedRu(value, 2)} %`;
}

/**
 * Доля исхода — проценты с одним знаком: «33,3 %». Контракт отдаёт долю
 * единицы 0..1 (`OutcomeShares`), в отличие от отскока и дисконта, которые
 * уже в процентах, поэтому здесь умножение на 100 — единица измерения, а не
 * расчёт.
 */
export function formatShare(value: number | null): string {
  return value === null ? MISSING : `${fixedRu(value * 100, 1)} %`;
}

/** Счётчик с разделителями разрядов. */
export function formatCount(value: number): string {
  return groupThousands(String(value));
}
